<template>
  <div class="flex justify-between text-gray-700">
    <span>
      <MoskitoTooltip :body="description" />
      <span>
        {{ header }}
      </span>
    </span>
    <span :class="`text-${color}-600 font-bold`">
      {{ audit.displayValue }}
    </span>
  </div>
</template>

<script>
import { getColorForScore } from "@/utils/pagespeed";

export default {
  name: "PagespeedAuditMetricItem",
  props: {
    audit: { type: Object, required: true },
    header: { type: String, default: "" },
    description: { type: String, default: "" },
  },
  computed: {
    color() {
      return getColorForScore(this.audit.score);
    },
  },
};
</script>

<style></style>
